/**
 * Каталог стяжек. На плане стяжка — косая штриховка цветом своего вида.
 */
import { LayerKind } from "@/shared/plan/layerKind";
import type { CatalogSection } from "../../types";
import { ScreedMaterial, type ScreedCatalogItem } from "./types";

export const screedSection: CatalogSection<ScreedCatalogItem> = {
	kind: LayerKind.Screed,
	label: "Стяжка",
	canChangeDimensions: false,
	subGroups: ["Сухая", "Полусухая", "Пескобетонная"],
	items: [
		{
			id: "screed-dry",
			material: ScreedMaterial.Dry,
			subGroup: "Сухая",
			name: "Сухая стяжка",
			description: "Сборная стяжка из листов ГВЛ или ЦСП по засыпке.",
			color: "#22c55e",
		},
		{
			id: "screed-semi-dry",
			material: ScreedMaterial.SemiDry,
			subGroup: "Полусухая",
			name: "Полусухая стяжка",
			description: "Цементно-песчаная стяжка с минимумом воды, затирается машиной.",
			color: "#eab308",
		},
		{
			id: "screed-concrete-sand",
			material: ScreedMaterial.ConcreteSand,
			subGroup: "Пескобетонная",
			name: "Пескобетонная стяжка",
			description: "Классическая мокрая стяжка из пескобетона.",
			color: "#3b82f6",
		},
	],
};
